import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";

import { ErrorScreen } from "./ErrorScreen";

/** The router's error component: a failed `beforeLoad`, loader or render of a route. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <ErrorScreen
      error={error}
      onRetry={() => {
        reset();
        void router.invalidate();
      }}
    />
  );
}
